import { forwardRef, useRef, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Form, Button, Select } from 'antd'
import { withBounds } from 'Components'
import { setGraphEditingLabels } from 'Actions/graph'
import { useHotKeys } from 'Hooks'
import Feather from '@sysunite/react-feather'

EditLabelsPopover = forwardRef(({ setGraphEditingLabels, editingLabelProps, style }, ref) ->
  { labels } = editingLabelProps
  [loading, setLoading] = useState(true)
  [existingLabels, setExistingLabels] = useState([])
  [currentLabels, setCurrentLabels] = useState([])

  close = ->
    setGraphEditingLabels(undefined)

  useHotKeys([{
    sequence: 'esc'
    fn: close
    expr: editingLabelProps
    temporary: true
    watchers: [editingLabelProps]
  }])

  getLabels = ->
    setExistingLabels(await Weaver.Set.list())
    setLoading(false)

  onSelect = (value) ->
    setCurrentLabels([
      currentLabels...
      value
    ])

  useEffect( ->
    setCurrentLabels(labels.map((label) -> label.uid))
  , [labels])

  useEffect(->
    getLabels()
    undefined
  , [])

  onDeselect = (value) ->
    newLabels = [ currentLabels... ]
    newLabels.splice(currentLabels.indexOf(value), 1)
    setCurrentLabels(newLabels)

  <div ref={ref} style={{ boxShadow: 'rgba(0,0,0,0.06) 0px 4px 12px 0px', borderRadius: '9px', padding: '16px', zIndex: 2, position: 'fixed', style... }}>
    <Form layout="inline" fields={[{ name: 'labels', value: currentLabels }]} onFinish={editingLabelProps.promise?.resolve}>
      <Form.Item>
        <Button type="link" onClick={close}><Feather type="x" /></Button>
      </Form.Item>
      <Form.Item name="labels">
        <Select onDeselect={onDeselect} onSelect={onSelect} loading={loading} style={{ width: '400px' }} mode="tags">
          {
            existingLabels.map((label) ->
              <Select.Option key={label.uid} value={label.uid}>
                { label.name }
              </Select.Option>
            )
          }
        </Select>
      </Form.Item>
      <Form.Item>
        <Button htmlType="submit" type="primary">Save</Button>
      </Form.Item>
    </Form>
  </div>
)

export default connect(({graph: { editingLabelProps }}) ->
  { editingLabelProps }
, { setGraphEditingLabels }
)(withBounds(EditLabelsPopover))

